import z from 'zod';

export const calendarDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

export const calendarDateRange = z.object({
  start: calendarDateSchema,
  end: calendarDateSchema,
});

export type CalendarDateRange = z.infer<typeof calendarDateRange>;
